// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewSearchSuggestion_container__AlBFB","icon":"ReviewSearchSuggestion_icon__ghoyu"};